import { useDispatch, useSelector } from 'react-redux';

import { ObjectOverallRating } from '../../components/ObjectOverallRating';
import { getObjectInfo } from '../../selectors/objectInfo';
import { openRatingInfoModal } from '../../actions/modals';
import { TThunkDispatch } from '../../types/redux';

export function ObjectOverallRatingContainer() {
  const dispatch = useDispatch<TThunkDispatch>();
  const { rating, formattedObjectName, reviewsCount } = useSelector(getObjectInfo);

  const onInfoClick = () => {
    dispatch(openRatingInfoModal());
  };

  if (!reviewsCount) {
    return null;
  }

  return (
    <ObjectOverallRating
      value={rating}
      formattedObjectTitle={formattedObjectName}
      reviewCount={reviewsCount}
      onInfoClick={onInfoClick}
    />
  );
}
